<template>
  <main id='Stories'>
    <KioskStories v-if="kiosk" />
    <section v-else-if='kirby.page.template == "stories" || kirby.page.template == "story"'>
      <h1 v-once v-html='kirby.pages.stories.strings.title' />
      <tags id='Featured-Tags' :tags='kirby.pages.stories.strings.featured_tags.split(", ").concat("My Story Collection")' @selectTag='selectTag($event)' :select='selectedTag' />
      <tags :tags='tags' :filtered='kirby.pages.stories.strings.featured_tags.split(", ")' @selectTag='selectTag($event)' :select='selectedTag' />
      <PlayList target='_self' :stories='yaml(kirby.pages.stories.strings.stories)' :tags.sync='tags' :filtered='selectedTag' />
      <MainFooter />
    </section>
  </main>
</template>

<style scoped>

</style>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function(){
    return {
      tags: [],
      selectedTag: false
    }
  },
  created: function(){
    this.selectedTag = window.location.hash.substring(1).replaceAll('_',' ').replace('ambersand','&');
    console.log(this.selectedTag);
  },
  methods: {
    selectTag: function(tag){
      this.selectedTag = (this.selectedTag == tag) ? '' : tag;
      window.location.hash = tag.replaceAll(' ', '_').replace('&', 'ambersand')
    }
  }
}
</script>

<style scoped>

  main {
    padding-top: 8em;
  }

  section {
    padding: var(--main-padding);
    max-width: var(--main-max-width);
    box-sizing: border-box;
    margin: auto;
  }

</style>

<style>

  #Stories article:hover * {
    color: var(--blue) !important;
  }

  #Featured-Tags a {
    background-color: white;
  }

</style>
